export default __webpack_public_path__ + "static/media/alerts1.dbf6f8ed.svg";